import { useQuery } from '@tanstack/react-query';
import {
  type Forms_InformationRequestListFormFilter,
  type QueryAdditionalOptions,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { infoRequestKeys } from './keys';

const infoRequestFormList = graphql(/* GraphQL */ `
  query forms_listInformationRequestForms(
    $filter: Forms_InformationRequestListFormFilter
  ) {
    forms_listInformationRequestForms(filter: $filter) {
      name
      id {
        provider
        forPartyId
        objectId
      }
      status
      completionDate
      dueDate
      forPerson {
        partyId
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
`);

const infoRequestFormListQuery = (
  filter: Forms_InformationRequestListFormFilter,
) => ({
  queryKey: infoRequestKeys.list(filter),
  queryFn: () => gqlClient.request(infoRequestFormList, { filter }),
});

export function useInfoRequestFormList(
  filter: Forms_InformationRequestListFormFilter,
  additionalOptions?: Omit<QueryAdditionalOptions, 'academicNamespaceId'>,
) {
  return useQuery({
    ...infoRequestFormListQuery(filter),
    ...additionalOptions,
    select: ({ forms_listInformationRequestForms }) =>
      forms_listInformationRequestForms,
  });
}

export function getInfoRequestFormList(
  filter: Forms_InformationRequestListFormFilter,
) {
  return queryClient.fetchQuery(infoRequestFormListQuery(filter));
}

export type ReturnTypeFromUseInfoRequestFormList = UseQueryReturnType<
  typeof useInfoRequestFormList
>[number];
